<template>
    <div class="modal__search-form">


        <form  class="modal__form" action="">
            <div :class="{
                'modal__search-bar': true,
                'modal__search-bar--has-results': hasResults,
            }">
                <button type="submit"><i class="icon-search"></i></button>
                <input :disabled="isLoading" @input="onInputEventHandler" ref="tire_search" type="text" :value="searchState.query"
                    :placeholder="handleSearchPlaceholder">
            </div>
        </form>
        <div v-if="searchState.searchType !== 'motorsport'" class="search-form__filter-wrapper">
            <div v-if="filterCategories" class="search-form__filter">
                <button ref="showFiltersBtn" @click="() => {
                showFilterOptions = !showFilterOptions
            }" :class="{
                'search-form__generic-btn': true,
                'search-form__generic-btn--active': showFilterOptions
            }" for="filter_tire_type">Filter
                    Tire Type {{ selectedFilterOptions.length ? `(${selectedFilterOptions.length})` : null }}</button>

                <div v-show="showFilterOptions" ref="filterOptions"
                    class="search-form__filter-options tire-filter-item__submenu">
                    <ul class="tire-filter-item__submenu-content tire-filter-item__submenu-content--overflow">
                        <li v-for="(category, index) in filterCategories" :key="'category_' + index"
                            class="tire-filter-submenu__item">
                            <label>
                                <input type="checkbox" name="categories" :value="category.term_id"
                                    v-model="selectedFilterOptions" class="form__checkbox">
                                {{ category.name }} </label>
                        </li>
                    </ul><!-- END tire-filter-item__submenu -->
                </div>
            </div>


            <ul v-if="displayedActiveCategories" class="search-form__active-categories-wrapper">
                <ul class="search-form__active-categories">
                    <li class="search-form__active-category" v-for="activeCateg, index in displayedActiveCategories"
                        :key="'active_categ_' + index">
                        {{ activeCateg.name }}
                        <button @click="removeActiveCategory(activeCateg.term_id)">
                            ✕
                        </button>
                    </li>
                </ul>

            </ul>
        </div>


        <div v-if="showLoadSpeedToolTip && !isLoading" class="modal__loadspeed-tooltip">
            <div class="tooltip">
                <i class="icon icon--info-white"></i>
            </div>
            <a :href="urls.loadSpeedRatingLink ? urls.loadSpeedRatingLink.url : ''"
                :target="urls.loadSpeedRatingLink ? urls.loadSpeedRatingLink.target : ''">Why does load
                rating matter?</a>
        </div>
        <div v-if="!isLoading && !searchState.isError" class="modal__content">
            <div :class="'modal__lists ' + (showSizeGuide ? '' : 'modal__lists--full')">
                <ul v-for="(list, index) in renderedLists" :key="'list_' + index" class="modal__list">
                    <template v-if="list.data.length">
                        <div class="modal__body">
                            <h4 class="modal__title">{{ list.title }}</h4>
                        </div>
                        <ul class="modal__results">
                            <li v-for="(item, index) in list.data" :key="item.type + `_${index}`">
                                <button :class="{ 
                                    modal__result: (!showLoadSpeedToolTip ||  showLoadSpeedToolTip && index),
                                    'search-form__generic-btn': showLoadSpeedToolTip && !index
                                }
                                    " @click="handleResultClick(item)">
                                    <div v-html="searchState.searchPhase === 1 ? item.value : formatOr(item.label)">

                                    </div>

                                </button>
                            </li>
                        </ul>
                    </template>
                </ul>
            </div>

            <div v-if="showSizeGuide" class="modal__size-guide">
                <a href="/wp-content/themes/truemarket/assets/images/tire-size-guide-full.png" target="_blank">
                    <img src="/wp-content/themes/truemarket/assets/images/tire-size-guide.png"
                        alt="Tire Warehouse tire size guide">
                </a>
            </div>
        </div>

        <p class="modal__error" v-if="searchState.isError">
            {{ searchState.errorMsg }}
        </p>
    </div>
</template>

<script>


import { VueSpinner } from "vue3-spinners";

import axios from "axios";
import Fuse from "fuse.js"

export default {
    data() {
        return {
            motorSportMode: false,

            selectedFilterOptions: [],
            filterCategories: [],
            showFilterOptions: true,
            urls: {
                baseUrl: externalAPIEndpoint, // This is coming from the /truemarket/header.php component
                vTrims: "/vehicle-trims/search",
                loadSpeedRatings: "/loadspeed-ratings/search",
                tires: "/tires",
                loadSpeedRatingLink: (() => {
                    try {
                        return JSON.parse(loadSpeedRatingLink)
                    } catch (error) {
                        return {}
                    }
                })(), // Declared in the header.php file

            },
            searchState: {
                query: '',
                searchType: "",
                isError: false,
                errorMsg: "",
                isLoading: false,
                searchPhase: 1, // Different lists will be rendered depending of phase of the search
            },
            fuseOptions: {
                useExtendedSearch: true,
                threshold: 0.35,
                distance: 1000,
                ignoreLocation: true,
                minMatchCharLength: 1,
                keys: [
                    'value'
                ]
            },

            // potentially show only tires list if user clicks change tires from shop-tires page
            listFirstPhase: [],
            // Conditionally rendered list depending on btn click.
            jsonLists: {
                // vehicle: carsJson,
                // tire_size: tireSizesJson,
                // tire_model: tireModels
                // motorsport: motorsportJson

            },
            // This list gets populated after a user clicks on a result found from the
            // first list
            listSecondPhase: [],
            //
            lists: {
                vehicle: {
                    title: "Vehicle",
                    data: [],
                },
                tire_size: {
                    title: "Tire Size",
                    data: [],
                },
                tire_brand: {
                    title: "Tire Brand",
                    data: []
                },
                tire_model: {
                    title: "Tire Model",
                    data: []
                },
                item_number: {
                    title: "Item Number",
                    data: []
                },

            },

            secondLists: {
                vehicle_trim: {
                    title: "Vehicle Trim",
                    data: [],
                },
                tire_size: {
                    title: "Load / Speed Rating",
                    data: [],
                },
            },
        };
    },

    components: {
        VueSpinner,
    },
    props: {
        userSelectedData: {
            type: Object,
        },
        isLoading: {
            type: Boolean
        }
    },
    computed: {
        displayedActiveCategories() {
            if (!this.selectedFilterOptions.length) {
                return
            }
            return this.selectedFilterOptions.map(categID => {
                const founcCateg = this.filterCategories.find(categ => categ.term_id == categID)
                return founcCateg
            })
        },

        handleSearchPlaceholder() {
            const searchType = this.searchState.searchType;
            if (searchType == 'motorsport') {
                return "Search by tire size / brand / item #";
            }
            else if (searchType === "vehicle") {
                return "Search by vehicle";
            } else if (searchType === "tire_size") {
                return "Search by tire size / tire brand";
            } else return "Search by tire size / vehicle / tire brand";
        },

        searchableList() {
            if (this.searchState.searchType) {
                return this.jsonLists[this.searchState.searchType];
            } else if (!this.searchState.searchType && this.listFirstPhase.length) {
                return this.listFirstPhase;
            } else {
                return []
            }
        },
        renderedLists() {
            const listToRender = this.searchState.searchPhase === 1
                ? this.lists
                : this.secondLists;

            return Object.values(listToRender).filter(list => list.data.length)
        },
        hasResults() {
            let hasResults = false;
            Object.values(this.lists).forEach((list) => {
                if (list.data.length) {
                    hasResults = true;
                    return;
                }
            });
            return hasResults;
        },

        vTrimsUrl() {
            return this.urls.baseUrl + this.urls.vTrims;
        },
        loadSpeedRatingsUrl() {
            return this.urls.baseUrl + this.urls.loadSpeedRatings;
        },

        tiresUrl() {
            return this.urls.baseUrl + this.urls.tires;
        },

        showSizeGuide() {
            return this.searchState.searchType !== 'motorsport' && this.lists.tire_size.data.length;
        },

        showLoadSpeedToolTip() {
            return this.secondLists.tire_size.data.length
        }
    },
    methods: {
        removeActiveCategory(termID) {
            this.selectedFilterOptions = this.selectedFilterOptions.filter(categ => categ !== termID)
        },

        handleClickOutside(e) {
            const target = e.target
            if (!this.$refs?.filterOptions?.contains(target) && this.$refs.showFiltersBtn !== target) {
                this.showFilterOptions = false
            }
        },
        /**
         * Happens any time the user types on the typeahead component
         * @param {Event} event
         */
        onInputEventHandler(event) {
    
            const newVal = event.target.value
            this.searchState.query = newVal
            const fuseResults = new Fuse(this.searchableList, this.fuseOptions).search(`${newVal} | '${newVal}`, { limit: 50 })
            this.searchState.searchPhase = 1;
            this.resetListsData();
            if (this.searchState.searchType !== 'motorsport' ? newVal.length < 3 : newVal.length < 1) {
                this.resetSearchErrorState();
                return;
            }

            if (!fuseResults.length) {
                this.searchState.isError = true;
                this.searchState.errorMsg =
                    "Could not find any results based on your query";
                return;
            } else {
                const lists = this.lists;
                fuseResults.forEach((item) => {
                    lists[item.item.type]?.data.push(item.item);
                });
                this.resetSearchErrorState();
                this.lists = lists;
            }
        },


        resetSearchErrorState() {
            this.searchState.isError = false;
            this.searchState.errorMsg = null;
        },

        sortJsonData(items) {
            return items.sort((a, b) => {
                if (a.value < b.value) {
                    return 1;
                }
                if (a.value > b.value) {
                    return -1;
                }
            });
        },
        handleResultClick(item) {
            
            if (this.searchState.searchType == 'motorsport') {
                this.handleMotorSportClick(item);
            }

           else if (this.searchState.searchPhase === 2) {
                this.searchState.query += " " + item.value
                this.sendFinalResultToParent(item);

            } else if (item.type === 'tire_model' || item.type === 'tire_brand') {
                this.searchState.query = item.value
                this.sendFinalResultToParent(item);
            }
            else {
                this.searchState.query = item.value
                this.sendFirstResultToParent(item);
                this.sendSearchToApi(item);
            }
        },


        sendFirstResultToParent(item) {
            const newData = this.userSelectedData;
            newData[item.type] = this.handleSentSearchParams(item);
    
            this.$emit("update:user-selected-data", newData);
            this.$emit('build-history', item)
        },

        handleMotorSportClick(item){
            const data = this.handleSentSearchParams(item);
            data.motorSport = true
            const newData = this.userSelectedData;
            newData[item.type] = data
            this.$emit('setIsLoading', true)
            this.$emit('build-history', item)
            this.$emit("update:user-selected-data", newData);
            this.$emit("onFinalized", newData);
        },


        handleFinalItemFormat(item) {
            const newData = this.userSelectedData;

            newData['categories'] = this.selectedFilterOptions
            if (item.type === 'tire_brand' || item.type === "tire_model") {
                newData[item.type] = this.handleSentSearchParams(item)
            } 
            else {
                newData[item.tire_data ? "tire_size" : "loadSpeedRating"] =
                    item.tire_data
                        ? item.tire_data

                        : { tLoadSpeed: item.tLoadSpeed };

                if (item.vTrim) {
                    newData.vehicle.vTrim = item.vTrim;
                }


                if (item.tire_data && item.hasOwnProperty('rear_tire_data') && item.rear_tire_data.rear) {
                    newData['tire_size'] = {
                        ...newData['tire_size'],
                        ...this.formatRearTireData(item.rear_tire_data)
                    }
                }

            }
            return newData
        },

        formatRearTireData(rearTireData) {
            return {
                rtWidth: rearTireData.tWidth ?? null,
                rtRatio: rearTireData.tRatio ?? null,
                rtRim: rearTireData.tRim ?? null,
                rtFormat: rearTireData.tFormat ?? null,
                rtLoadSpeed: rearTireData.tLoadSpeed ?? null,
                tireToggle: 'front'
            }
        },


        sendFinalResultToParent(item) {
            const newData = this.handleFinalItemFormat(item)
            this.$emit('build-history', item)
            this.$emit("update:user-selected-data", newData);
            this.$emit("onFinalized", newData);
        },

        showPostalCodeForm() {
            this.$emit("showPostalCodeForm");
        },

        /**
         * Since there are two possible phases of the search, we need to send the initial
         * search results to the API in order to retrieve the second list of results. (vehicle trims or load speed ratings)
         * @param {Object} data
         * @returns null
         */
        sendSearchToApi(data) {
            this.$emit('setIsLoading', true)
            // this.searchState.isLoading = true;
            let dataToSend = this.handleSentSearchParams(data);

            axios
                .get(this.handleSearchUrl(data.type), {
                    params: dataToSend,
                    headers: {
                        "X-API-KEY": "2eb51489-d4d2-43a0-ad0f-28b44f4df67c",
                    },
                })
                .then((res) => {
                    if (res.data.length || res.data.loadspeedOptions && res.data.loadspeedOptions.length) {
                        if (data.type === 'tire_size') {
                            this.secondLists.tire_size.data.push(this.getAllLoadSpeedsOption())
                        }
                        this.secondLists[
                            data.type === "vehicle"
                                ? "vehicle_trim"
                                : "tire_size"
                        ].data =
                            data.type === "vehicle"
                                ? res.data
                                : [
                                    ...this.secondLists.tire_size.data,
                                    ...res.data.loadspeedOptions
                                ];

                        this.searchState.searchPhase = 2;
                    } else {
                        this.searchState.isError = true;
                        this.searchState.errorMsg =
                            "Could not find any results based on your query";
                    }
                })
                .catch((err) => {
                    this.searchState.isError = true;
                    this.searchState.errorMsg = err.message;
                })
                .finally(() => {
                    this.$emit('setIsLoading', false)
                });
        },

        /**
         * Determines what url to send a request to depending on type of result clicked
         * by the user.
         * @param {String} type
         */
        handleSearchUrl(type) {
            let returnedUrl = "";
            switch (type) {
                case "vehicle": {
                    returnedUrl = this.vTrimsUrl;
                    break;
                }
                case "tire_size": {
                    returnedUrl = this.loadSpeedRatingsUrl;
                }
            }
            return returnedUrl;
        },

        /**
         * Determines which parameters to send to the API request depending on type of data
         * clicked from the search results.
         * @param {Object} suggestion
         */
        handleSentSearchParams(suggestion) {
            let selectedData = {};
            switch (suggestion.type) {
                // store the following so it can be referenced in the WP site and also passed to Laravel API
                case "vehicle":
                    selectedData = {
                        // type: suggestion.type,
                        vYear: suggestion.tokens[0],
                        vMake: suggestion.tokens[1],
                        vModel: suggestion.tokens[2],
                    };
                    /**
                     * This data will need to send to API so we can return a list of Trim levels to them to select from.
                     * Once they select a trim level, store that as `vTrim` and redirect to search results IF we have postal code.
                     * It's possible all trim levels will have the same tire size, in which case we won't ask them to select a trim, so the API will
                     * send some sort of message that will indicate to move on to search results (if we have postal code)
                     */
                    break;
                case "tire_size":
                    if (suggestion.format == "flotation") {
                        selectedData = {
                            // type: suggestion.type,
                            tFormat: suggestion.format,
                            tDiameter: suggestion.tokens[0],
                            tWidth: suggestion.tokens[1],
                            tRim: suggestion.tokens[2],
                            tLabel: suggestion.value,
                        };
                    } else {

                        selectedData = {
                            // type: suggestion.type,
                            tFormat: "metric",
                            tWidth: suggestion.tokens[0],
                            tRatio: suggestion.tokens[1],
                            tRim: suggestion.tokens[2],
                        };
                    }
                    /**
                     * This data will send to the API so that we can return a list of load/speed ratings for the user to select from.
                     * Once they select an option, store as `tLoadSpeed` and redirect to search results (if postal).
                     * It's unlikely, but possible that the tire size will have only one load/speed rating, in which case we won't ask the
                     * user to select one. We'll just redirect directly to search results.
                     */
                    break;
                case "tire_brand":
                    selectedData = {
                        // type: suggestion.type,
                        mBrand: suggestion.tokens[0],
                    };
                    /**
                     * Can go directly to search results IF we have postal code
                     */
                    break;
                case "tire_model":
                    selectedData = {
                        // type: suggestion.type,
                        mBrand: suggestion.tokens[0],
                        mModel: suggestion.tokens[1],
                    };
                    /**
                     * Can go directly to search results IF we have postal code
                     */
                    break;
                case "item_number":
                    selectedData = {
                        itemNumber: suggestion.tokens[0]
                    };
                    /**
                     * Can go directly to search results IF we have postal code
                     */
                    break;
                default:
                    break;
            }

            return selectedData;
        },

        /**
         * Since each keypress by the user yields new results, we need to reset the
         * rendered lists
         */
        resetListsData() {
            const lists = this.lists;
            const secondLists = this.secondLists;
            Object.keys(lists).forEach((listKey) => {
                lists[listKey].data = [];
            });

            Object.keys(secondLists).forEach((listKey) => {
                secondLists[listKey].data = [];
            });
            this.lists = lists;
            this.secondLists = secondLists;
            this.$emit('clear-search-history')
        },


        getAllLoadSpeedsOption() {
            return {
                "value": "Search All Load Speed Ratings",
                "label": "Search All Load Speed Ratings",
                "tLoadSpeed": ""
            }
        },


        formatOr(label) {
            return label.split(' or ').join("<span class='highlight'> or </span>");
        },


        getSearchData() {
            this.$emit('setIsLoading', true)
            fetch('/wp-json/json/v1/search?')
                .then(async res => {
                    const data = await res.json()
                    this.filterCategories = data.categories
                    const urlParams = new URLSearchParams(window.location.search);
                    const categories = urlParams.get('categories');
                    if (categories) {
                        try {
                            this.selectedFilterOptions = JSON.parse(categories)
                        } catch (error) {
                            console.log('error parsing category URL query')
                        }
                    }
                    this.jsonLists = data
                    this.listFirstPhase = [...data.vehicle, ...data.tire_size, ...data.tire_model]
                    window.dispatchEvent(
                        new CustomEvent("enable-filter-buttons", {
                            detail: true,
                        }));
                })
                .catch(err => {
                    this.searchState.errorMsg = 'There was a problem fetching the search data'
                    this.searchState.isError = true
                })
                .finally(() => {
                    this.$emit('setIsLoading', false)
                })
        },


        handleSearchWinterChange() {
            this.isSearchingWinter = !this.isSearchingWinter

            window.dispatchEvent(
                new CustomEvent("search-winter-only-home", {
                    detail: this.isSearchingWinter,
                })
            );
        }

    },
    async mounted() {
        document.addEventListener('click', this.handleClickOutside);
        this.getSearchData()
        window.addEventListener("send-list-type", (event) => {
            if (this.searchState.searchType != event.detail) {
                    this.searchState.query = "";
                    this.resetListsData();
            }
            this.searchState.searchType = event.detail;
            this.searchState.searchPhase = 1;
        });

    },
};
</script>

